"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponentsModifiers = require("styled-components-modifiers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const modifierConfig = {
  center: () => "\n    left: 50%;\n    transform: translateX(-50%);\n  ",
  right: () => "\n    left: auto;\n    right: 0;\n  ",
  up: () => "\n    bottom: 1.25rem;\n  "
};

const ListWrap = _styledComponents.default.div.withConfig({
  displayName: "ListWrap"
})(["display:", ";position:absolute;left:0;margin-top:0.5rem;background-color:white;white-space:nowrap;border:1px solid ", ";z-index:2;border-radius:4px;", ";"], props => props.open ? 'block' : 'none', props => props.theme.palette.border, (0, _styledComponentsModifiers.applyStyleModifiers)(modifierConfig));

var _default = ListWrap;
exports.default = _default;
ListWrap.propTypes = {
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(modifierConfig),
  open: _propTypes.default.bool
};
ListWrap.defaultProps = {
  open: false
};